import { Head, Link } from '@inertiajs/react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { AppLayout } from '@/layouts/AppLayout'
import { rootPath } from '@/lib/routes'

function NotFound() {
  return (
    <section className="flex min-h-[70vh] items-center justify-center px-4 py-32">
      <Head title="404" />

      <div className="mx-auto flex max-w-5xl flex-col items-center text-center">
        <p
          className="font-black leading-none tracking-tight text-primary"
          style={{ fontSize: 'clamp(7rem, 22vw, 22rem)' }}
        >
          404
        </p>
        <p className="mt-4 text-2xl font-semibold text-foreground">Page not found.</p>
        <Link className="mt-10" href={rootPath()}>
          <Button size="lg">Back home</Button>
        </Link>
      </div>
    </section>
  )
}

export default Object.assign(NotFound, {
  layout: (page: ReactNode) => <AppLayout>{page}</AppLayout>,
})
